// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';
// import { setCookie } from 'helper/cookie';
// import { parseJWT } from 'helper/jwt';
// import Swal from 'sweetalert2';
// import Color from 'constants/color.constants';

export const getPayrateUserAll = async ({ token, params } : any) => {
   try {
      return await client
         .get(`payrate_user`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params,
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getPayrateUserById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`payrate_user_by_id`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getPayrateUserTypeById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`payrate_user_type`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const postCreatePayrateUser = async ({ token, params } : any) => {
   try {
      return await client
         .post(`payrate_user`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const putUpdatePayrateUser = async ({ token, params, id } : any) => {
   try {
      return await client
         .put(`payrate_user/${id}`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const deletePayrateUser = async ({ token, id } : any) => {
   try {
      return await client
         .delete(`payrate_user/${id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getPayrateUserMyGruopUserAll = async ({ token, params } : any) => {
   try {
      return await client
         .get(`payrate_group_all`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params,
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const getPayrateDealerById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`payrate_user_dealer_by_id`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};
